import { Plus } from '@phosphor-icons/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { useAgGridClientTableContext } from 'core/states';
import { IPartBom, IPartBomItem } from 'partBoms/types';
import { Color } from 'theme/enums';

import { UpsertItem } from './UpsertItem';

interface IProps {
  partBom: IPartBom;
}

export const AddItemButton = ({ partBom }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const { updateRows } = useAgGridClientTableContext();

  const handleOnClose = () => setIsOpen(false);

  const onSubmitSuccess = (partBomItem: IPartBomItem) => {
    updateRows({ add: [partBomItem] }, { goToRowIndex: partBomItem.line - 1 });
  };

  return (
    <>
      <Button
        text={t('buttonLabelAddPartBomItem')}
        color={Color.SUCCESS}
        startDecorator={<Plus />}
        onClick={() => setIsOpen(true)}
      />

      <UpsertItem
        isOpen={isOpen}
        onClose={handleOnClose}
        partBom={partBom}
        onSubmitSuccess={onSubmitSuccess}
      />
    </>
  );
};
